export const MAILING_LIST_ROUTING = {
  unsubscribeMail: 'unsubscribe-mail',
} as const;
